const textColor = 'rgb(51, 51, 51)'
const staticStyle = {
  commentText: {
    fontSize: 14,
    lineHeight: '21px',
    color: textColor,
  },
  seeMoreText: {
    fontSize: 14,
    lineHeight: '21px',
    cursor: 'pointer',
    color: '#0a8cd2',
    marginLeft: 5,
  },
}

export default staticStyle
